import React, { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { Search } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { SearchModal } from '../SearchModal';
import { GlobalUtilContext } from '../../../../contexts';

function SearchInput() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { search } = useContext(GlobalUtilContext);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        padding: '8px 0 5px',
        visibility: isOpen ? 'hidden' : 'block'
      }}
    >
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="#9B959F" sx={{ mr: 1, cursor: 'pointer' }} />
            </InputAdornment>
          ),
          type: 'search'
        }}
        disabled
        fullWidth
        id="search-input-fullWidth"
        onClick={() => setIsOpen(true)}
        placeholder={t('search.search')}
        sx={{
          cursor: 'pointer',
          '& .MuiInputBase-input.Mui-disabled': {
            padding: 0,
            cursor: 'pointer',
            WebkitTextFillColor: '#00010E',
            opacity: 1
          },
          '& .MuiInputBase-input.Mui-disabled::placeholder': {
            WebkitTextFillColor: '#9B959F',
            opacity: 1,
            fontSize: 14,
            fontWeight: 400
          },
          '& .MuiInputBase-root': {
            padding: '10px 19px',
            borderRadius: 1,
            cursor: 'pointer',
            background: 'white',
            border: '1px solid rgba(155,149,159,0.26)',
            boxShadow: '1px 2px 8px 0px rgba(155,149,159,0.26)'
          }
        }}
        value={search}
      />
      <SearchModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </Box>
  );
}

SearchInput.propTypes = {};

export { SearchInput };
